export default __webpack_public_path__ + "static/media/kefu.585a8028.svg";